export default __webpack_public_path__ + "b65ac3b8da9f6efd334607d7386c9f0e.ttf";